import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Produit } from "../core/model/produit";
import { TypeCredit } from "../core/model/type-credit";
import { ProduitService } from "../core/service/produit.service";
import { TypeCreditService } from "../core/service/type-credit.service";

@Component({
  selector: "app-produit",
  templateUrl: "./produit.component.html",
  styleUrls: ["./produit.component.scss"],
})
export class ProduitComponent implements OnInit {
  produits: Produit[];
  typeCreditId: number;
  typeCredit: TypeCredit;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _produitService: ProduitService,
    private _typeCreditService: TypeCreditService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.typeCreditId = params["typeCreditId"];
      this.getProduitByTypeCredit(this.typeCreditId);
      this.getyTypeCreditById(this.typeCreditId);
    });
  }

  getProduitByTypeCredit(typeCreditId) {
    this._produitService.getListproduitByTypeCredit(typeCreditId).subscribe(
      (data) => {
        this.produits = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getyTypeCreditById(typeCreditId) {
    this._typeCreditService.getTypeCreditById(typeCreditId).subscribe(
      (data) => {
        this.typeCredit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(typeCreditId): void {
    this._router.navigate(["/parametrage/produit/add-produit/" + typeCreditId]);
  }
}
